<template>
    <div class="sms-setup-workflow">
        <sms-setup-modal :is-open="isSetupModalOpen" @close="handleClose" @next="completeProvision" />

        <sms-setup-complete-modal
            :from-number="fromNumber"
            :account="account"
            :is-open="isSetupCompleteModalOpen"
            :is-billing-changes-enabled="isBillingChangesEnabled"
            @close="closeCompleteModal"
            @update="handleAccountUpdate"
        />

        <kmn-verification-form
            v-if="kmnPhoneVerificationEnabled && isKmnProvisioned"
            :is-open="isKmnVerificationModalOpen"
            :kmn-account="account"
            :is-kmn-branded-opt-in-enabled="isKmnBrandedOptInEnabled"
            @close="handleClose"
            @complete="openCompleteModal"
        />
    </div>
</template>

<script>
import SmsSetupModal from './SmsSetupModal';
import SmsSetupCompleteModal from './SmsSetupCompleteModal';
import KmnVerificationForm from '@/components/broadcast/sms/KmnVerificationForm';

const SETUP_MODAL = 'SETUP_MODAL';
const SETUP_COMPLETE_MODAL = 'SETUP_COMPLETE_MODAL';
const KMN_VERIFICATION_MODAL = 'KMN_VERIFICATION_MODAL';

export default {
    components: { SmsSetupCompleteModal, SmsSetupModal, KmnVerificationForm },

    props: {
        fromNumber: String,
        isKmnBrandedOptInEnabled: Boolean,
        kmnPhoneVerificationEnabled: Boolean,
        isBillingChangesEnabled: Boolean,
    },

    data() {
        return {
            isKmnProvisioned: false,
            currentModal: SETUP_MODAL,
            account: {},
        };
    },

    computed: {
        isSetupModalOpen() {
            return this.currentModal === SETUP_MODAL;
        },

        isSetupCompleteModalOpen() {
            return this.currentModal === SETUP_COMPLETE_MODAL;
        },

        isKmnVerificationModalOpen() {
            return this.currentModal === KMN_VERIFICATION_MODAL;
        },
    },

    methods: {
        handleClose() {
            this.currentModal = null;
            this.$emit('close');
        },

        handleAccountUpdate(updatedAccount) {
            this.account = {
                ...this.account,
                ...updatedAccount,
            };
        },

        completeProvision(account) {
            this.$emit('account-created', account);
            this.account = account;
            this.isKmnProvisioned = true;

            if (this.kmnPhoneVerificationEnabled) {
                this.currentModal = KMN_VERIFICATION_MODAL;
            } else {
                this.currentModal = SETUP_COMPLETE_MODAL;
            }
        },

        openCompleteModal() {
            this.$emit('verification-complete');
            this.currentModal = SETUP_COMPLETE_MODAL;
        },

        closeCompleteModal() {
            this.$emit('setup-complete');
            this.currentModal = null;
        },
    },
};
</script>
